<div
  class="kng-filter"
  [ngStyle]="{ display: state.hidden ? 'none' : 'block' }"
>
  <div class="kng-filter__container">
    <div class="kng-filter__header">
      <span class="kng-filter__textcolor" tabindex="0">{{
        state.filterData.heading.label
      }}</span>
      <button
        class="kng-filter__btnposition"
        mat-button
        (click)="closeFilter()"
      >
        <img src="/assets/close-filter-icon.svg" alt="Close Filter">
      </button>
    </div>
    <div class="kng-filter__body">
      <form class="add-field">
        <ng-container
          *ngFor="
            let sectioncontrol of state.filterData.sections;
            let sectionIndex = index
          "
        >
          <mat-accordion class="kng-filter__headers-align" [class]="'sectionAddress-' + sectioncontrol.label" multi *ngIf="!sectioncontrol.hidden">
            <mat-expansion-panel
              #sectionCollapsed
              [expanded]="sectioncontrol.collapsed"
              (opened)="sectioncontrol.collapsed = true"
              (closed)="sectioncontrol.collapsed = false"
              hideToggle="true"
            >
              <mat-expansion-panel-header [id]="isSectionWithSearchInput(sectioncontrol.collapsed, sectioncontrol)">
                <mat-panel-title #sectionLabel >
                  {{ sectioncontrol.label }}
                  <span
                    *ngIf="
                      sectioncontrol.selectedValue &&
                      sectioncontrol.selectedValue.length !== 0
                    "
                  >
                  &nbsp;({{ sectioncontrol.selectedValue.length }})
                  </span>
                </mat-panel-title>
                <mat-panel-description>
                  <img
                    *ngIf="sectioncontrol.collapsed"
                    class="expansion-icon"
                    alt="{{ sectioncontrol.accordionExpandedIcon.altText }}"
                    [src]="isRaymond ? expandedIconRaymond : sectioncontrol.accordionExpandedIcon.iconPath"
                  />
                  <img
                    *ngIf="!sectioncontrol.collapsed"
                    class="expansion-icon"
                    alt="{{ sectioncontrol.accordionCollapsedIcon.altText }}"
                    [src]="isRaymond ? collapsedIconRaymond : sectioncontrol.accordionCollapsedIcon.iconPath"
                  />
                </mat-panel-description>
              </mat-expansion-panel-header>
              <ng-container *ngFor="let control of sectioncontrol.controls; let controlIndex = index">
                <ng-container *ngIf="control && control.type !== 'none' && displayRecordsHandler(sectioncontrol, controlIndex)">
                  <div
                    *ngIf="control.type === 'radio' || control.type ==='Not Date'"
                    class="form-group _item"
                  >
                    <mat-radio-group class="filter-fields">
                      <mat-radio-button
                        [formControl]="control"
                        ngDefaultControl
                        *ngFor="let options of control.options; let j = index"
                        [checked]="options.checked"
                        value="{{ options.value }}"
                        (change)="checkSelectedValue(j,sectionIndex)"
                        tabindex="-1"
                        (keypress)="checkSelectedValue(j,sectionIndex)"
                      >
                        <span class="radio-option" tabindex="0">{{ options.label }}</span>
                      </mat-radio-button>
                      <div *ngIf="showToFromInput && control.type !== 'Not Date'" class="formField">
                        <div>
                          <mat-form-field>
                            <label>From</label>
                            <input
                              id="fromDateInput"
                              matInput
                              [matDatepicker]="fromPicker"
                              [max]="maxFromDate"
                              [min]="minFromDate"
                              [ngClass]="
                                fromDateError
                                  ? 'mat-datepicker-input-witherror'
                                  : 'mat-datepicker-input-noerror'
                              "
                              (click)="fromPicker.open()"
                              [value]="fromDate"
                              (input)="onKeyUp($event)"
                              (dateChange)="checkDateValidator($event)"
                            />
                            <mat-datepicker-toggle
                              class="calender"
                              matSuffix
                              [for]="fromPicker"
                            >
                            </mat-datepicker-toggle>
                            <mat-datepicker #fromPicker></mat-datepicker>
                            <div class="errorfield" *ngIf="fromDateError">
                              {{calendarConstants.fromDateError}}
                            </div>
                          </mat-form-field>
                        </div>
                        <div>
                          <mat-form-field>
                            <label>{{calendarConstants.toLabel}}</label>
                            <input
                              id="toDateInput"
                              matInput
                              [matDatepicker]="toPicker"
                              [max]="maxToDate"
                              [min]="minToDate"
                              [ngClass]="
                                toDateError
                                  ? 'mat-datepicker-input-witherror'
                                  : 'mat-datepicker-input-noerror'
                              "
                              (click)="toPicker.open()"
                              [value]="toDate"
                              (dateChange)="checkDateValidator($event)"
                              (input)="onKeyUp($event)"
                            />
                            <mat-datepicker-toggle
                              class="calender"
                              matSuffix
                              [for]="toPicker"
                            >
                            </mat-datepicker-toggle>
                            <mat-datepicker #toPicker></mat-datepicker>
                            <div class="errorfield" *ngIf="toDateError">
                              {{calendarConstants.toDateError}}
                            </div>
                          </mat-form-field>
                        </div>
                      </div>
                    <div *ngIf="othersInput && control.type === 'Not Date'" class="formField">
                      <div>
                        <mat-form-field>
                          <label>{{calendarConstants.monthsLabel}}</label>
                          <input
                              id="otherInput"
                              matInput
                              [value]="othersMonthValue"
                              class="monthsInput"
                            />
                        </mat-form-field>
                      </div>
                    </div>
                    </mat-radio-group>
                  </div>

                  <div
                    *ngIf="control.type === 'input'"
                    [hidden]="control.isHidden"
                    class="form-group _item search-section"
                  >
                    <div
                      class="search-wrapper"
                      ngClass="{'search-wrapper--with-image': control.inputIcon}"
                    >
                      <input  (keydown.enter)="$event.preventDefault()"
                        id="{{ control.label }}"
                        [formControl]="control"
                        ngDefaultControl
                        placeholder="{{ control.inputPlaceholderText }}"
                        class="search-fields"
                        type="text"
                        matInput
                        autocomplete="off"
                      />
                      <button class="clear" *ngIf="control.value?.length>0" (click)="clearSearch(control)" tabindex="-1">
                        <img
                          [src]="sectioncontrol.crossIcon.iconPath"
                          [alt]="sectioncontrol.crossIcon.altText"
                          tabindex="0"
                        />
                      </button>
                    </div>
                  </div>

                  <div
                    *ngIf="control.type === 'checkbox'"
                    class="form-group filter-fields" tabindex="0"
                  >
                    <mat-checkbox
                      [formControl]="control"
                      class="_item"  #checkbox
                      matInput
                      (change)="checkboxClicked(sectioncontrol)" (onclick)="updateCheckedStateForAccessibility($event, checkbox)"
                    >
                      <p [ngClass]="{'location':control.isLocation}">{{ control.label }}</p>
                      <p *ngIf="control.isLocation && control.address">{{ formatAddress(control.address) }}</p>
                    </mat-checkbox>
                  </div>
                </ng-container>
              </ng-container>

              <div
                *ngIf="noResultsFound(sectioncontrol)"
                class="form-group _item no-results-found"
              >
                {{ sectioncontrol.noResultsFoundText }}
              </div>
              <div
                *ngIf="isErrorMessage(sectioncontrol)"
                class="form-group _item no-results-found"
              >
                {{ sectioncontrol.errorMessage }}
              </div>
              <div
              *ngIf="
                sectioncontrol.controls.length === 0 && sectioncontrol.noAssociatedResultsFoundText
              "
              class="form-group _item no-results-found"
            >
              {{ sectioncontrol.noAssociatedResultsFoundText }}
            </div>
              <div
              *ngIf="isShowMorePresent(sectioncontrol)"
              class="form-group _item show-more-less"
            >
              <button *ngIf="sectioncontrol.controls.length > 5 && sectioncontrol.showMoreShowLess && !sectioncontrol.showMoreShowLess.isShowMoreClicked && sectioncontrol.showMoreShowLess.showMoreText" [disabled]="isShowMoreDisabled(sectioncontrol)" (click)="handleDynamicDisplayOfShowMoreShowLess(sectioncontrol.showMoreShowLess.showMoreText, sectioncontrol)">{{ sectioncontrol.showMoreShowLess.showMoreText }}</button>
              <button *ngIf="sectioncontrol.controls.length > 5 && sectioncontrol.showMoreShowLess && sectioncontrol.showMoreShowLess.isShowMoreClicked && sectioncontrol.showMoreShowLess.showLessText" [disabled]="isShowMoreDisabled(sectioncontrol)" (click)="handleDynamicDisplayOfShowMoreShowLess(sectioncontrol.showMoreShowLess.showLessText, sectioncontrol)">{{ sectioncontrol.showMoreShowLess.showLessText }}</button>
            </div>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-container>
      </form>
    </div>
    <div class="kng-filter__footer">
      <button
        *ngFor="let button of state.filterData.ctaList; let i = index"
        #ctaButton
        id="{{ button.id }}"
        class="btn {{ button.className }}"
        (click)="
          buttonClicked({ event: $event, buttonClicked: button, state: state })
        "
        [disabled]="button.disabled"
        tabindex="0"
      >
        {{ button.label }}
      </button>
    </div>
  </div>
  <div></div>
</div>
